const _prefix = '@route/';

export default {
  CHANGE_LAYOUT_ROUTE: _prefix + 'CHANGE_LAYOUT_ROUTE',
  SET_HISTORY: _prefix + 'SET_HISTORY',
  UPDATE_ROUTE: _prefix + 'UPDATE_ROUTE',
  CHANGE_ROUTE: _prefix + 'CHANGE_ROUTE',
  CACHE_ROUTE: _prefix + 'CACHE_ROUTE'
};
